import { Component, OnInit , AfterViewInit } from '@angular/core';
import {HomeComponent} from '../home/home.component';

declare var $ : any;

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit , AfterViewInit{
  isNext:boolean=false;
  userTypeId:number=-1;
  planId:number=-1;
  constructor(private home:HomeComponent) { }

  ngOnInit() {
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
  }

  ngAfterViewInit(){
    $('.cd-header').css('backgroundColor','rgb(147, 18, 70)');
  }

  showActiveModule(pvarId){
    this.home.showActiveModule(pvarId);
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/team/team.component.ts